import React, {useState} from 'react';
import {IoIosArrowBack, IoIosArrowForward} from 'react-icons/io'
import {FaInstagram, FaFacebookF,FaWhatsapp} from 'react-icons/fa'
import Headings from './Headings';

// Import Swiper styles

import img1 from '../Images/testimonial/w2.jpg'
import img2 from '../Images/testimonial/m1.jpg'
import img3 from '../Images/testimonial/m2.jpg'
import img4 from '../Images/testimonial/m3.jpg'
import img5 from '../Images/testimonial/w3.jpg'

const Testimonial = () => {
  const [currIndex, setCurrIndex] = useState(0);

  const prevSlide = () => {
    const isFirstSlide = currIndex === 0;
    const newIndex = isFirstSlide ? slides.length - 1 : currIndex - 1;
    setCurrIndex(newIndex);
  }

  const nextSlide = () => {
    const isLastSlide = currIndex === slides.length-1;
    const newIndex = isLastSlide ? 0 : currIndex + 1;
    setCurrIndex(newIndex);
  }

  const goToSlide = (slideIndex) => {
    setCurrIndex(slideIndex);
  }

  const slides = [
    {
      url : img1,
      head: " Anitha H",
      comp:"anita123@gmail.com",
      para:"I am happy and thankful for the support I have received from you people. Without you guys I can’t imagine such a fast & smooth process for my personal loan application. A Big Thank you for all the services.",
      facebook:'https://www.facebook.com',
      instagram:'https://www.instagram.com',
      whatsapp:'https://www.whatsapp.com'

    },
    {
      url : img2,
      head: " Vijay Kumar",
      comp:"vijaykumar@gmail.com",
      para:"I would like to thank you for the wonderful and excellent service provided for applying loan. I am very satisfied with your service and would like to continue in future too.",
      facebook:'https://www.facebook.com',
      instagram:'https://www.instagram.com',
      whatsapp:'https://www.whatsapp.com'

    },
    {
      url : img3,
      head: "RAVINDRA ",
      comp:"ravindrapratapsinghtomar@gmail.com",
      para:"I would like to thank from bottom of my soul for your valued guidance from the first day I have applied for the loan. WISHING BEST FOR YOUR FUTURE.",
      facebook:'https://www.facebook.com',
      instagram:'https://www.instagram.com',
      whatsapp:'https://www.whatsapp.com'

    },
    {
      url : img4,
      head: " Varun",
      comp:"varun12145@gmail.com",
      para:"The suggestions and advice given by you are good and you have been very cooperative during the interactions we had on call. You explained the policy well",
      facebook:'https://www.facebook.com',
      instagram:'https://www.instagram.com',
      whatsapp:'https://www.whatsapp.com'

    },
    {
      url : img5,
      head: "Meera",
      comp:"meera121@gmail.com",
      para:"Thanks for your best quality service. I am grateful to you.",
      facebook:'https://www.facebook.com',
      instagram:'https://www.instagram.com',
      whatsapp:'https://www.whatsapp.com'

    },
  ]

  return (
    <div className='py-10'>
      <Headings headings='Testimonials' className='mb-8' />

    <div className='sm:flex font-montserrat justify-center sm:mx-[120px] sm:my-[20px] my-[20px] py-10 px-4 relative'>
        {/* Left */}
        <div className='sm:w-[440px] content-center'>
          <img width={400} height={400} src={slides[currIndex].url} alt="" className='rounded-full object-cover mx-auto' />
        </div>

        {/* Right */}
        <div className='sm:pl-20'>
          <div className='flex pt-[20px] justify-between'>
            <div className='flex flex-col'>
              <h1 className='font-bold sm:text-[45px] text-[20px] sm:pr-[200px] md:w-[500px] w-[200px]'>{slides[currIndex].head}</h1>
              <h1 className='sm:text-[16px] text-[13px] text-[#7c7c7c] mt-2'>{slides[currIndex].comp}</h1>
            </div>
            <div className='flex sm:py-6'>
              <div className='text-2xl sm:pr-4 pr-3 cursor-pointer text-[#7c7c7c] hover:text-[#000] ' onClick={prevSlide}>
                <IoIosArrowBack />
              </div>
              <div className='text-2xl cursor-pointer text-[#7c7c7c] hover:text-[#000]' onClick={nextSlide}>
               <IoIosArrowForward/>
              </div>
            </div>
          </div>
          <div>
            <p className='text-justify sm:pt-6 pt-3 sm:w-[500px] sm:text-[20px] text-[13px]'>{slides[currIndex].para}</p>
            <div className='text-[#b12929] flex justify-between sm:w-[30%] w-[50%] sm:my-6 my-4'>
              <a href={slides[currIndex].facebook} target='_blank' rel='noreferrer'><FaFacebookF className='hover:text-[#DC2E2E] mr-[10px]' size={20}/></a>
              <a href={slides[currIndex].instagram} target='_blank' rel='noreferrer'><FaInstagram className='hover:text-[#DC2E2E] mr-[10px]' size={20}/></a>
              <a href={slides[currIndex].whatsapp} target='_blank' rel='noreferrer'><FaWhatsapp className='hover:text-[#DC2E2E] mr-[10px]' size={20}/></a>
            </div>
            <div className='flex sm:pt-12 sm:gap-8 gap-6 sm:justify-end justify-start sm:py-6 py-3'>
              {slides.map((slide, slideIndex) => (
              <div key={slideIndex} onClick={() => goToSlide(slideIndex)} className='text-2xl cursor-pointer'>
              <img width={50} height={50} className='rounded-full hover:scale-125 object-cover' src={slides[slideIndex].url} alt="" />
              </div>
            ))}
            </div>
          </div>
        </div>
      
    </div>
    </div>

  )
  
}

export default Testimonial
        